import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import { getCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneSize } from '@Components/BigBrowse/Model/ModelTypes';
import { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import type { ViewData } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';

export function getMultiSectionHeroCard(
  viewData: ViewData,
  size: PlaneSize,
  dx = 0
): GridCard<PlaneTypes.Card_MultiSection_Hero> {
  const card = getCard<PlaneTypes.Card_MultiSection_Hero>({
    type: PlaneTypes.Card_MultiSection_Hero,
    size,
    blockHover: true,
    data: {
      dx,
      dataModel: viewData.modelData,
      id: ['BrandConcessionHero', viewData.modelData.concessionId].join('_'),
      key: ['BrandConcessionHero', viewData.modelData.concessionId].join('_'),
      imageUrl: viewData.modelData.header.heroImageUrl,
      isViewHero: true,
      type: undefined,
      sectionId: viewData.modelData.concessionId,
    },
  });

  card.key = card.data?.key;

  return card;
}
